var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordSword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.82 96.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h87.82v96.25H0z",
    fill: "#748EC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2 96.1h-2.33v-9.2a109.19 109.19 0 0 0-1-16.07A107.66 107.66 0 0 0 38 55.06a31.26 31.26 0 0 0 3.73-7.26 35.09 35.09 0 0 0 1.45-8.33 28.2 28.2 0 0 0-4.62.61q-1.63.4-6 2a16.79 16.79 0 0 1-4.93 1.11 4.19 4.19 0 0 1-3.23-1.34 4.94 4.94 0 0 1-1.24-3.48 5 5 0 0 1 1.32-3.53 4.12 4.12 0 0 1 3.15-1.45 7.08 7.08 0 0 1 2.44.4L33.2 35q1.07.4 4.62 1.47a32.55 32.55 0 0 0 5.28 1l-.46-3.76a32.49 32.49 0 0 0-.82-3.35q-.92-3.35-1.78-6.1Q39 20.94 38.77 20a8.42 8.42 0 0 1-.23-2 5.47 5.47 0 0 1 1.55-4A5.29 5.29 0 0 1 44 12.46 5.23 5.23 0 0 1 47.91 14a5.36 5.36 0 0 1 1.55 3.91l-1.52 6.3q-.86 2.7-1.78 6.1l-.8 3.38-.46 3.73a32.64 32.64 0 0 0 5.28-1l4.62-1.47 3.2-1.16a6.62 6.62 0 0 1 2.28-.4 4.32 4.32 0 0 1 3.3 1.42 5.5 5.5 0 0 1 .1 7 4 4 0 0 1-3.15 1.34 16.86 16.86 0 0 1-5-1.11q-4.42-1.57-6-2a27.92 27.92 0 0 0-4.65-.61 37.62 37.62 0 0 0 .64 5.23A28.48 28.48 0 0 0 47 49.38a33 33 0 0 0 3 5.69 112.76 112.76 0 0 0-3.83 15.77 106.57 106.57 0 0 0-1 16.07z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordSword);
export default __webpack_public_path__ + "static/media/WordSword.dda8d33fd1f231cf75f964b74fdea036.svg";
export { ForwardRef as ReactComponent };